// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://mkibvjygzrqqqdbewftv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1raWJ2anlnenJxcXFkYmV3ZnR2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA0MDM2NjUsImV4cCI6MjA4NTk3OTY2NX0.YxJCP77cWHyMMsiW-DpwJyHcJ66k5dLzYRwzJL9O2fU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});